/*
 * DefaultSelect.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Sat Feb 04 2023 mys Company
 */

import { useEffect, useState } from 'react'
import uuid from 'react-uuid'
import { localization } from '../../config/localize/localizable'

const DefaultSelect = ({ label, id, name, items = [], inputClassName, className, isRequire = false, inputValue, onChange, itemValue, itemCaption, errorMessage, formik }) => {
    //
    // MARK: VARIABLE
    const [uuId, setUuId] = useState()
    const [showError, setShowError] = useState(false)
    const [isLoad, setIsLoad] = useState(false)

    //
    // MARK: METHOD

    useEffect(() => {
        setUuId(uuid())
    }, [])

    useEffect(() => {
        if (inputValue) setIsLoad(true)
    }, [inputValue])

    const handleChange = async (e) => {
        if (e.target.value === '0') {
            setShowError(true)
            if (onChange) onChange(null)
            return
        }
        setShowError(false)
        let val = items[e.target.selectedIndex - 1][itemValue]
        if (onChange) onChange(val)
        if (formik) formik.setFieldValue(name, val)
    }

    if (formik) inputValue = formik.values[name] ?? false

    return (
        <>
            {isLoad ? (
                <div className={` ${className ?? ''}`}>
                    <label className={`w-100 block  text-sm `}>{label}</label>
                    <select
                        name={name}
                        value={inputValue}
                        id={id ?? name + '_' + uuId}
                        className={`w-full border border-gray-100 rounded shadow-sm p-2 outline-none text-sm ${inputClassName ?? ''}`}
                        onChange={handleChange}
                        // onBlur={handleChange}
                    >
                        <option value="-1">{localization.chooseone}</option>
                        {items &&
                            items.map((item, index) => {
                                return (
                                    <option key={index} value={item[itemValue]}>
                                        {item[itemCaption]}
                                    </option>
                                )
                            })}
                    </select>
                </div>
            ) : (
                <>
                    <label className={`w-100 block  text-sm `}>{label}</label>
                    <select className={`w-full border border-gray-100 rounded shadow-sm p-2 outline-none text-sm ${inputClassName ?? ''}`} onChange={handleChange} value={inputValue}>
                        <option value="0">{localization.chooseone}</option>
                        {items &&
                            items.map((item, index) => {
                                return (
                                    <option key={index} value={item[itemValue]}>
                                        {item[itemCaption]}
                                    </option>
                                )
                            })}
                    </select>
                </>
            )}
            <div className={`text-red-500 text-xs ${showError ? '' : 'hidden'} `}>{errorMessage}</div>
        </>
    )
}

export default DefaultSelect
